import {Component, Input, OnInit} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {DetaillineDTOModel} from '../../models/detaillineDTO.model';
import {DocumentModel} from '../../models/document.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {FindEquipmentPriceService} from '../../services/find-equipment-price.service';
import {FindProductPriceService} from '../../services/find-product-price.service';
import {DateAsNumberService} from '../../services/date-as-number.service';
import {GeneralService} from '../../services/general.service';
import {CollectionsNames} from '../../definitions/collections-names';
import {MobileConfigurationModel} from '../../models/mobile-configuration.model';
import {DocumentTypes} from '../../definitions/document-types';
import {ConfigurationService} from '../../services/configuration.service';
import { StateManagerService } from 'src/app/services/state-manager.service';
import { BundleItemModel } from 'src/app/models/bundle-item.model';

@Component({
    selector: 'edit-bundle-items',
    templateUrl: './edit-bundle-items.page.html',
    styleUrls: ['./edit-bundle-items.page.scss'],
})
export class EditBundleItemsPage implements OnInit {
    @Input() document: DocumentModel;
    @Input() customerRepairItem: DetaillineDTOModel;

    tempList: any = [];
    bundleItems: BundleItemModel[] = [];

    constructor(private modalController: ModalController,
                private lokiJs: LokijsService,
                private stateManager: StateManagerService,
                private collNames: CollectionsNames,
                private generalService: GeneralService
                ) {
    }

    ngOnInit() {

        this.initialize();
    }

    initialize() {
        var  noAccessoriesChecked = true;

        this.tempList = [];
        this.bundleItems = this.stateManager.getCollection(this.collNames.DEFAULTBUNDLEITEMS);

        this.bundleItems.sort((a, b) => (a.description.toLowerCase() > b.description.toLowerCase()) ? 1 : -1);
        // sort so that "= No Accessories" is at the start (LES)
        this.bundleItems.sort((a, b) => (a.description.toLocaleLowerCase().match(".*no accessories.*")) ? -1 : 1);


        console.log( this.bundleItems );
        var isCheckedValue = false;

        if( this.customerRepairItem && !this.customerRepairItem.bundleItems ){
            this.customerRepairItem.bundleItems = [];
        }

        for (const bundleItem of this.bundleItems) {
            // logic needed here to mark checked or not TODO
            isCheckedValue = false;
            



            if(!this.customerRepairItem){
                for(const each of this.document.serviceJob.bundleItems ){
                    if( bundleItem.productTypeId === each.productTypeId ){
                        isCheckedValue = true;
                        noAccessoriesChecked = false;
                        break;
                    }
                }
            }else{
                
                console.log(this.customerRepairItem);
                for(const each of this.customerRepairItem.bundleItems ){
                    if( bundleItem.productTypeId === each.productTypeId ){
                        isCheckedValue = true;
                        noAccessoriesChecked = false;
                        break;
                    }
                } 
            }
            // add wrapper item
            this.tempList.push({item: bundleItem, isChecked: isCheckedValue });
        }

        // if nothing is check default the first item to be checked

        /*if( noAccessoriesChecked ){
            this.tempList[0].isChecked = true;
        }*/
   
    }

    async saveAccessories() {
        var validAccessories: boolean = false;



        if(!this.customerRepairItem){
            // clear out existing bundleItems
            this.document.serviceJob.bundleItems = [];

            // then update 
            for (const wrapper of this.tempList) {
                if (wrapper.isChecked) {
                // its a valid list of accessories ( there must always be at least one)
                validAccessories = true;
                    this.document.serviceJob.bundleItems.push( wrapper.item );
                }
            }
        }else{
            // clear out existing bundleItems
            this.customerRepairItem.bundleItems = [];

            // then update 
            for (const wrapper of this.tempList) {
                if (wrapper.isChecked) {
                // its a valid list of accessories ( there must always be at least one)
                validAccessories = true;
                    this.customerRepairItem.bundleItems.push( wrapper.item );
                }
            } 
        }

        if( validAccessories ){
            this.modalController.dismiss();
        }else{
            this.generalService.createToast('Please select at least one accessory');

        }
    }


   
}
